import { RequestTaxInvoiceType } from "../../../enum/builk/package-sale/request-tax-invoice-type.enum";

export class CreateRequestInvoiceModel {
    companySurrKey: number;
    transactionSurrKey: number;
    packageInvoiceType: number;
    name: string;
    email: string;
    phone: string;
    taxId: string;
    address: string;
    taxPhone: string;
    branch: string;
    contactName: string;
    countryCode: string;
    provinceCode: string;
    districtCode: string;
    country: string;
    province: string;
    district: string;
    relateOf: number;
    postcode: string;
}

export class ProjectTransactionInvoiceDetailModel {
    projectPackageInvoiceSurrKey: number;
    transactionSurrKey: number;
    packageInvoiceType: number;
    name: string;
    email: string;
    phone: string;
    taxId: string;
    address: string;
    taxPhone: string;
    branch: string;
    contactName: string;
    countryCode: string;
    provinceCode: string;
    districtCode: string;
    country: string;
    province: string;
    district: string;
    requestTaxInvoiceType: RequestTaxInvoiceType;
    transactionCode: string;
    personType?: number;
    postcode: string;
}
